import { BottomSheet } from "react-spring-bottom-sheet";
import { Button, Container } from "reactstrap";

export const ComingSoon = ({ isOpen, onClose }) => {
	return (
		<BottomSheet open={isOpen} onDismiss={onClose}>
			<Container>
				<div className="pt-50 mb-150">
					<h2 className="f-16 fw-900 mb-50">بزودی...</h2>
					<p className="fw-400 f-12 mb-150">بزودی این سرویس و سرویس‌های جذابِ جدید به کارو اضافه می‌شه!</p>
					<Button block color="primary" onClick={onClose}>
						متوجه شدم
					</Button>
				</div>
			</Container>
		</BottomSheet>
	);
};
